exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drop[data-v-8d54872a]{width:100%;height:100%;top:0;border-radius:10px;position:absolute;background-color:#f4f6ff;left:0;border:3px dashed #a3a8b1}.beforeUpload[data-v-8d54872a]{position:relative;text-align:center}.beforeUpload input[data-v-8d54872a]{width:100%;margin:auto;height:100%;opacity:0;position:absolute;background:red;display:block}.beforeUpload input[data-v-8d54872a]:hover,.plus[data-v-8d54872a]:hover{cursor:pointer}", ""]);

// exports
